import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=fc3720ea&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=ts"
export * from "./ChatBot.vue?vue&type=script&lang=ts"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=fc3720ea&prod&lang=scss&scoped=true"
import style1 from "./ChatBot.vue?vue&type=style&index=1&id=fc3720ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3720ea",
  null
  
)

export default component.exports